import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ThemeContext } from "../../../context/ThemeContext";
import LogoutPage from "./Logout";

const Header = ({ onNote }) => {
 // const { setAffiliateProfile } = useContext(AffiliateProfileContext);
  const { changeBackground } = useContext(ThemeContext);
  const [profileInfo, setProfileInfo] = useState({});
const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`
  useEffect(() => {
    const path = window.location.pathname;
    const isAffiliate = path.includes("/afiliado");
    const storageKey = "userDetailsAfiliate";
    const afiliadoData = JSON.parse(window.localStorage.getItem(storageKey));
    if (afiliadoData) {
      
     // setAffiliateProfile(afiliadoData);
      setProfileInfo(afiliadoData);

     
    }
  }, []);

  const [headerFix, setheaderFix] = useState(false);
  useEffect(() => {
    const handleScroll = () => setheaderFix(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    
  }, []);

  //const path = window.location.pathname.split("/");
  //const name = path[path.length - 1].split("-");
  // const filterName = name.length >= 3 ? name.slice(1) : name;
  // const keywords = ["app", "ui", "uc", "basic", "jquery", "table", "page", "email", "ecom", "chart", "editor"];
  // const finalName = filterName.filter((f) => !keywords.includes(f));

  return (
    <div className={`header ${headerFix ? "is-fixed" : ""}`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>
            <div className="navbar-nav header-right">
              <div className="dz-side-menu">
                <div className="sidebar-social-link "></div>
                <ul>
                  <Dropdown as="li" className="nav-item dropdown header-profile">
                    <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                      <img
                        src={
                          profileInfo?.employee?.credentialData?.credentialPhoto ? serverHost + profileInfo?.employee?.credentialData?.credentialPhoto : "https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg"
                        }
                        alt=""
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="right" className="dropdown-menu dropdown-menu-end">
                      <LogoutPage />
                    </Dropdown.Menu>
                  </Dropdown>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
